import { EmployeeModuleTabPath_Rewarding } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/RewardingModule/data';

export enum EmployeeProposalsTabs {
  SalaryProposal = 'SalaryProposal',
  ShortTermIncentivesProposal = 'ShortTermIncentivesProposal',
  BillableHoursProposal = 'BillableHoursProposal',
  BenefitProposal = 'BenefitProposal',
  AllowanceProposal = 'AllowanceProposal',
  ProposalsHistory = 'ProposalsHistory',
}

export enum EmployeeRewardingProposalDialogTabs {
  General = 'general',
  Incentives = 'incentives',
  BillableHours = 'billable-hours',
  Benefits = 'benefits',
  Allowances = 'allowances',
}

export const convertRewardingModuleTabsToEmployeeProposalDialogTabs = (
  enabledTabs: EmployeeModuleTabPath_Rewarding[],
): EmployeeRewardingProposalDialogTabs[] => {
  return enabledTabs.reduce((acc, tab) => {
    switch (tab) {
      case EmployeeModuleTabPath_Rewarding.General:
        return [...acc, EmployeeRewardingProposalDialogTabs.General];
      case EmployeeModuleTabPath_Rewarding.Incentives:
        return [...acc, EmployeeRewardingProposalDialogTabs.Incentives];
      case EmployeeModuleTabPath_Rewarding.BillableHours:
        return [...acc, EmployeeRewardingProposalDialogTabs.BillableHours];
      case EmployeeModuleTabPath_Rewarding.Benefits:
        return [
          ...acc,
          EmployeeRewardingProposalDialogTabs.Benefits,
          EmployeeRewardingProposalDialogTabs.Allowances,
        ];
      default:
        return acc;
    }
  }, [] as EmployeeRewardingProposalDialogTabs[]);
};

export type EmployeeProposalsTab = {
  name: EmployeeProposalsTabs;
  disabled?: boolean;
  hasWorkflowConfigured?: boolean;
  available: boolean;
};

export const getEmployeeProposalsTabsTranslationKey = (
  employeeProposalsTab: keyof typeof EmployeeProposalsTabs,
): string => {
  const translationKeys: {
    [key in EmployeeProposalsTabs]: string;
  } = {
    [EmployeeProposalsTabs.SalaryProposal]: 'laSalaryProposal',
    [EmployeeProposalsTabs.ShortTermIncentivesProposal]:
      'laShortTermIncentivesBonusProp',
    [EmployeeProposalsTabs.BillableHoursProposal]: 'laBillableHoursProposal',
    [EmployeeProposalsTabs.BenefitProposal]: 'laBenefitProposal',
    [EmployeeProposalsTabs.AllowanceProposal]: 'laAllowanceProposal',
    [EmployeeProposalsTabs.ProposalsHistory]: 'laProposalsHistory',
  };

  return translationKeys[employeeProposalsTab];
};
